import '@ant-design/v5-patch-for-react-19';
import './assets/theme.css';

import App from 'App';
import { forceRemoteTheme } from 'helpers/forceRemoteTheme';
import { createRoot } from 'react-dom/client';
import { IS_PROD } from 'settings';

if (!IS_PROD) forceRemoteTheme();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
